
import BaseAnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class LandAnticipateAnimateSymbolBehaviour extends BaseAnimateSymbolBehaviour {

    public behaviourName: string = "AnticipateAnimateOver";

    /**
     * Only triggers when a win is possible, just as the symbol lands.
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAnimation="land_anticipate"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "land_anticipate") {
        super(symbol, defaultAnimation);
    }

    public landAnticipate(): Contract<void> {
        return this.animate("_land_anticipate", ["land_anticipate"], false, false);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
